import { Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Menu from "./pages/Menu";  
import ClockIn from "./pages/ClockIn";  
import ClockOut from "./pages/ClockOut";  
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import Tracking from "./pages/Tracking";
import PowerAdmin from "./pages/PowerAdmin"; 
import Power from "./pages/Power"; 

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("token")
  );

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Menu />} />
      <Route path="/absenclockin" element={<ClockIn />} />
      <Route path="/absenclockout" element={<ClockOut />} />
      <Route path="/login" element={<Login onLogin={setIsLoggedIn} />} />
      <Route
        path="/admin"
        element={
          isLoggedIn ? (
            <Admin onLogout={() => setIsLoggedIn(false)} />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Fitur lain */}
      <Route path="/tracking" element={<Tracking />} />
      <Route path="/poweradmin" element={<PowerAdmin />} /> 
      <Route path="/power" element={<Power />} /> 
    </Routes>
  );
}

export default App;
